import { NL_CARE_LOCALSTORAGE_KEY } from '@/configs/localstorage.config';
import { IUser } from '@/features/user/types/user.type';
import { deleteLocalStorageData, getLocalStorageData, saveLocalStorageData } from '@/utils/local-storage';

export const TOKEN_KEY = NL_CARE_LOCALSTORAGE_KEY + 'token';
export const USER_KEY = NL_CARE_LOCALSTORAGE_KEY + 'user';

const authLocalStorage = {
  getToken: () => {
    return getLocalStorageData(TOKEN_KEY);
  },
  setToken: (token: string) => {
    saveLocalStorageData(TOKEN_KEY, token);
  },
  clearToken: () => {
    deleteLocalStorageData(TOKEN_KEY);
  },
  getUser: () => {
    return getLocalStorageData(USER_KEY) as IUser;
  },
  setUser: (user: IUser) => {
    saveLocalStorageData(USER_KEY, user);
  },
  clearUser: () => {
    deleteLocalStorageData(USER_KEY);
  },
};

export default authLocalStorage;
